import SearchResultEventItem from './SearchResultEventItem';
import { useState, useEffect, useRef } from "react";

const SearchResultEvent = ({
    showResult,
    events,
    onSearchResultItemEnter,
    onSearchResultItemLeave,
    onSearchResultItemClicked,
    searchString,
    categories,
    selectedEvent,
    onSearchResultReset
}) => {

    const [isHiding, setIsHiding] = useState(false);
    const [collapsed, setCollapsed] = useState(false);
    const itemsRef = useRef(null);
    const lastScrollY = useRef(window.scrollY);

    const handleMouseEnter = (event, index) => {
        if (onSearchResultItemEnter) {
            onSearchResultItemEnter(event, index);
        }
    };

    const handleMouseLeave = (event, index) => {
        if (onSearchResultItemLeave) {
            onSearchResultItemLeave(event, index);
        }
    };

    const handleClick = (event, index) => {
        if (onSearchResultItemClicked) {
            onSearchResultItemClicked(event, index);
        }
    };

    const filteredBy = () => {
        const activeCategories = categories
            .filter(cat => cat.active)
            .map(cat => cat.label);

        return activeCategories.length > 0
            ? '(gefiltert nach ' + activeCategories.join(', ') + ')'
            : '';
    };

    const onClickReset = () => {
        setCollapsed(false);
        setIsHiding(true);
    }

    const onClickExpand = () => {
        setCollapsed(false);
    }

    const handleAnimationEnd = () => {
        if (isHiding && onSearchResultReset) {
            onSearchResultReset();
            setIsHiding(false);
        }
    };

    // 👇 Auto-collapse when user scrolls up and list is not visible
    useEffect(() => {
        if (showResult && !selectedEvent) {
            const observer = new IntersectionObserver(([entry]) => {
                const isVisible = entry.isIntersecting;
                const scrollY = window.scrollY;
                const scrollUp = scrollY < lastScrollY.current;
                lastScrollY.current = scrollY;
                if (!isVisible && scrollUp) {
                    setCollapsed(true);
                }
            }, {
                threshold: 0.1
            });

            const target = itemsRef.current;
            if (target) {
                observer.observe(target);
            }

            return () => {
                if (target) {
                    observer.unobserve(target);
                }
                observer.disconnect();
            };
        }
    }, [showResult, selectedEvent]);

    useEffect(() => {
        setCollapsed(false);
    }, [events]);

    return (
        <div ref={itemsRef} className={`search-result-container ${collapsed ? 'collapsed' : ''} ${isHiding ? 'fade-out' : ''}`} onAnimationEnd={handleAnimationEnd}>
            {showResult ? (
                <>
                    {/* put div around notice and result-items-container? */}
                    <div className={`search-result-notice px-4 py-3 ${collapsed ? 'collapsed' : ''}`}>Hier sind die <b>{events.length}</b> nächsten E3/DC-Fachpartner Events in der Nähe von {searchString} {filteredBy()}</div>
                    <div className={`search-result-items-container`}>
                        {Object.values(events).map((event, index) => (
                            <SearchResultEventItem
                                key={index}
                                event={event}
                                onMouseEnter={handleMouseEnter}
                                onMouseLeave={handleMouseLeave}
                                onClick={handleClick}
                                index={index}
                                isSelected={selectedEvent && selectedEvent.id === event.id}
                            />
                        ))}
                    </div>
                    {collapsed ? (
                        <div className='search-result-reset d-flex justify-content-center' onClick={onClickExpand}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-chevron-down" viewBox="0 0 16 16">
                                <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
                            </svg>
                        </div>
                    ) :
                        <div className='search-result-reset d-flex justify-content-center' onClick={onClickReset}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-chevron-up" viewBox="0 0 16 16">
                                <path fillRule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                            </svg>
                        </div>
                    }
                </>
            ) : (
                <div className='search-result-notice px-4 py-3'>Bitte geben Sie einen Ort ein, um E3/DC-Fachpartner Events in Ihrer Nähe zu finden.</div>
            )}
        </div>
    );
};

export default SearchResultEvent;
